module.exports = __webpack_public_path__ + "static/media/nasa_curiosity.cdfaa5ab.glb";